import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["trigger", "form"]

  show() {
    this.triggerTarget.classList.add("hidden")
    this.formTarget.classList.remove("hidden")
  }

  hide() {
    this.triggerTarget.classList.remove("hidden")
    this.formTarget.classList.add("hidden")
  }
}
